import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'received-orders',
            label: 'Pedidos Up-vendas',
            routerLink: ['/extensions/received-orders'],
            icon: 'shopping-cart',
        },
        'sales'
    ),
];
